import { colors, mediaQuery } from "../../../../../theme"

import { Currency } from "../../../../../utils/PriceUtil"
import { Discount } from "../../../../../api/products/variations/get/types"
import { Discount as DiscountIcon } from "../../../../../icons"
import { PriceView } from "../../../../../components/PriceView"
import { Trans } from "@lingui/macro"
import styled from "@emotion/styled/macro"
import { toLocalePrice } from "../../../../../utils"

type OffersDiscountProps = {
  discount: Discount
  currency: Currency
  price: number
  productId?: string
  index: number
}

export function OffersDiscount({
  discount,
  currency,
  price,
  productId,
  index,
}: OffersDiscountProps) {
  return (
    <DiscountContainer>
      <IconContainer>
        <DiscountIcon />
      </IconContainer>
      <DiscountInfo
        data-testid={`product-${productId}-offer-discount-${index}`}
      >
        <DiscountText>
          {discount.discountType === "P"
            ? ` ${discount.discountValue}% `
            : discount.discountValue != null &&
              ` ${toLocalePrice(discount.discountValue * 100, currency)} `}
          <Trans>de descuento</Trans>
        </DiscountText>
        <PaymentText>
          <Trans>pagando con</Trans>
          {` ${discount.name}`}
        </PaymentText>
        <PriceContainer>
          <OriginalPrice>
            <PriceView price={toLocalePrice(price, currency)} />
          </OriginalPrice>
          <DiscountedPrice>
            <PriceView
              price={toLocalePrice(discount.discountedPrice, currency)}
            />
          </DiscountedPrice>
        </PriceContainer>
      </DiscountInfo>
    </DiscountContainer>
  )
}

const DiscountContainer = styled.div({
  alignItems: "baseline",
  gap: "1.1rem",
  display: "grid",
  padding: "1.6rem 1.2rem 0.8rem",
  position: "relative",
  gridTemplateColumns: "18px 1fr",

  "& svg": {
    fontSize: "1.8rem",
    minWidth: "1.8rem",
    position: "absolute",
    top: 18,
  },

  [mediaQuery.desktop]: {
    padding: "0.4rem 2rem 1.2rem",

    "& svg": {
      top: 6,
    },
  },
})

const DiscountText = styled.span({
  color: "#00A650",
  marginRight: 4,
})

const PaymentText = styled.span({
  color: colors.greyDark,
})

const IconContainer = styled.span({
  width: "1.8rem",
  marginTop: 4,
})

const DiscountInfo = styled.div({ fontSize: "1.6rem" })

const PriceContainer = styled.div({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
})

const OriginalPrice = styled.span({
  textDecoration: "line-through",
  color: colors.greyMedium,
  fontSize: "1.6rem",
})

const DiscountedPrice = styled.span({
  fontWeight: "bold",
  fontSize: "1.6rem",
  color: colors.greyDark,
})
